import { __assign, __read, __values } from "tslib";
export function flattenObjectStructure(structure, omitClasses, indicator) {
    var e_1, _a;
    if (omitClasses === void 0) { omitClasses = []; }
    if (indicator === void 0) { indicator = ""; }
    var flattened = {};
    var _loop_1 = function (k, v) {
        var nKey = indicator.length > 0 ? indicator + "." + k : k;
        if (typeof v === 'object' && !Array.isArray(v) && omitClasses.find(function (className) { return v instanceof className; }) == void 0)
            flattened = __assign(__assign({}, flattened), flattenObjectStructure(v, omitClasses, nKey));
        else
            flattened[nKey] = v;
    };
    try {
        for (var _b = __values(Object.entries(structure)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var _d = __read(_c.value, 2), k = _d[0], v = _d[1];
            _loop_1(k, v);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    ;
    return flattened;
}
export function appendPathToObject(path, value, target) {
    if (target === void 0) { target = {}; }
    var keys = path.split(".");
    var current = keys.shift();
    var next = keys.join(".");
    if (!current)
        return;
    if (next.length === 0) {
        target[current] = value;
        return;
    }
    if (!target[current])
        target[current] = {};
    else if (typeof target[current] !== 'object' || Array.isArray(target[current]))
        target[current] = { base: target[current] };
    appendPathToObject(next, value, target[current]);
}
export function expandObjectParameters(target) {
    var e_2, _a;
    var structure = {};
    try {
        for (var _b = __values(Object.entries(target)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var _d = __read(_c.value, 2), k = _d[0], v = _d[1];
            appendPathToObject(k, v, structure);
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_2) throw e_2.error; }
    }
    return structure;
}
